import { colors } from 'fitify-ui'
import {
  phone,
  biggerPhoneLandscape,
  tabletPortrait,
  xsPhone,
  biggerPhone,
} from 'fitify-ui-landing/src/theme/breakpoints'
import { css } from 'styled-components'

/**
 * TextTypesVariants
 */
declare global {
  enum TextTypesVariants {
    'header-title' = 'header-title',
    'header-title-hc' = 'header-title-hc',
    'condensed-title' = 'condensed-title',
    'footer-copy' = 'footer-copy',
    'header-paragraph' = 'header-paragraph',
    'animated-image-group-label' = 'animated-image-group-label',
    'animated-image-group-value' = 'animated-image-group-value',
    'faq-title' = 'faq-title',
    'how-it-works-jump' = 'how-it-works-jump',
    'modal-title' = 'modal-title',
    'newsletter-title' = 'newsletter-title',
    'special-offer' = 'special-offer',
    'trainer-description' = 'trainer-description',
    'tryit-headline' = 'tryit-headline',
    'tryit-paragraph' = 'tryit-paragraph',
    'try-it-warning' = 'try-it-warning',
    'how-it-works-content' = 'how-it-works-content',
    'feature-content' = 'feature-content',
    'business-title' = 'business-title',
    'apps-title' = 'apps-title',
    'review-content' = 'review-content',
    'error-title' = 'error-title',
    'error-description' = 'error-description',
    'error-paragraph' = 'error-paragraph',
    'feature-title' = 'feature-title',
    'dg-feature-title' = 'dg-feature-title',
    'tool-title' = 'tool-title',
    'tool-subheadline' = 'tool-subheadline',
    'promo-title' = 'promo-title',
    'promo-paragraph' = 'promo-paragraph',
    'achievement-title' = 'achievement-title',
    'reviews-job' = 'reviews-job',
    'work-statistics-title' = 'work-statistics-title',
    'work-statistics-percent' = 'work-statistics-percent',
    'work-statistics-note' = 'work-statistics-note',
    'achievement-date' = 'achievement-date',
  }
}

export const textVariants = {
  'header-title': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 56px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 110%;

    ${biggerPhoneLandscape(css`
      font-size: 40px;
    `)};

    ${phone(css`
      font-size: 40px;
    `)};

    ${xsPhone(css`
      font-size: 32px;
    `)};
  `,
  'header-title-hc': css`
    color: ${colors.Black};
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 56px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.02em;
    line-height: 110%;

    ${biggerPhoneLandscape(css`
      font-size: 40px;
    `)};

    ${phone(css`
      font-size: 40px;
    `)};

    ${xsPhone(css`
      font-size: 32px;
    `)};
  `,
  'work-statistics-title': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  'work-statistics-percent': css`
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 56px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -1px;
    line-height: 120%;
  `,
  'work-statistics-note': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
  `,
  'condensed-title': css`
    font-family: 'Graphik XXCond Web', sans-serif;
    font-size: 64px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    text-transform: uppercase;

    ${biggerPhone(css`
      margin-top: 24px;
      font-size: 56px;
      letter-spacing: -0.56px;
    `)}
  `,
  'error-title': css`
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 88px;
    font-style: normal;
    font-weight: 500;
  `,
  'error-description': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 32px;
    font-weight: 500;
  `,
  'error-paragraph': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
  `,
  'how-it-works-jump': css`
    font-family: 'Graphik XXCond Web', sans-serif;
    font-size: 96px;
    font-style: normal;
    font-weight: 500;
    line-height: 90%;
    text-transform: uppercase;
  `,
  'how-it-works-content': css`
    color: ${colors.Gray700};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  `,
  'reviews-job': css`
    color: ${colors.Gray700};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
  `,
  'feature-content': css`
    color: ${colors.Gray700};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  `,
  'modal-title': css`
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.02em;
    line-height: 110%;

    ${phone(css`
      font-size: 32px;
    `)};
  `,
  'header-paragraph': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    ${biggerPhoneLandscape(css`
      font-size: 16px;
    `)};

    ${phone(css`
      font-size: 16px;
    `)};
  `,
  'tool-title': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;

    ${phone(css`
      font-size: 32px;
    `)};
  `,
  'tool-subheadline': css`
    color: ${colors.Gray800};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    ${biggerPhoneLandscape(css`
      font-size: 16px;
    `)};
  `,
  'tryit-headline': css`
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 56px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.02em;
    line-height: 120%;

    ${tabletPortrait(css`
      font-size: 48px;
    `)};
  `,
  'tryit-paragraph': css`
    color: ${colors.Gray800};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  `,
  'footer-copy': css`
    color: ${colors.Gray600};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
  `,
  'faq-title': css`
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    text-transform: capitalize;
  `,
  'newsletter-title': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  `,
  'try-it-warning': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 110%;
    text-transform: uppercase;
  `,
  'trainer-description': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  `,
  'business-title': css`
    color: ${colors.Blue900};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 110%;

    ${biggerPhone(css`
      margin-top: 24px;
      font-size: 40px;
    `)};
    ${phone(css`
      font-size: 32px;
    `)};
  `,
  'review-content': css`
    color: ${colors.Gray800};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
  `,
  'apps-title': css`
    color: ${colors.Blue900};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 48px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.02em;
    line-height: 120%;

    ${tabletPortrait(css`
      letter-spacing: -0.05em;
    `)};
    ${biggerPhone(css`
      font-size: 40px;
    `)};
    ${phone(css`
      font-size: 32px;
    `)};
  `,
  'animated-image-group-label': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
  `,
  'animated-image-group-value': css`
    font-family: 'Graphik Wide Web', sans-serif;
    font-size: 32px;
    font-weight: 500;
  `,
  'special-offer': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 14px;
    font-style: normal;
  `,
  'feature-title': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 120%;

    ${phone(css`
      font-size: 24px;
    `)}
  `,
  'dg-feature-title': css`
    color: ${colors.Blue900};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 32px;
    font-weight: 600;
    line-height: 120%;

    ${phone(css`
      font-size: 24px;
    `)}
  `,
  'achievement-title': css`
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 54px;
    font-weight: 600;
    line-height: 120%;
    text-align: center;

    ${phone(css`
      font-size: 40px;
    `)}
  `,
  'achievement-date': css`
    color: ${colors.Gray600};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 24px;
    font-weight: 500;

    ${phone(css`
      font-size: 20px;
    `)}
  `,
  'promo-title': css`
    color: ${colors.Blue900};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 32px;
    font-weight: 800;
    line-height: 120%;
  `,
  'promo-paragraph': css`
    color: ${colors.Gray500};
    font-family: 'Graphik LCG Web', sans-serif;
    font-size: 16px;
    line-height: 22px;
  `,
}
